import React from 'react'
import styled from 'styled-components'
import { MyTheme } from 'Components/common/Theme'
import { MerchantTaxData } from 'Store/tax-management/types'

type Props = {
  merchant?: MerchantTaxData
}

const PdfCompanyInfo: React.FunctionComponent<Props> = props => {
  const { merchant } = props

  return (
    <div>
      <CompanyName>{merchant?.name}</CompanyName>
      <CompanyInfo>{merchant?.address}</CompanyInfo>
      <CompanyInfo>เบอร์โทรศัพท์ {merchant?.mobile}</CompanyInfo>
      <CompanyInfo>เลขประจำตัวผู้เสียภาษี {merchant?.tax_invoice_no} </CompanyInfo>
    </div>
  )
}

const CompanyName = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.h5};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

const CompanyInfo = styled.div`
  font-size: ${(props: { theme: MyTheme }): string => props.theme.typography.body4};
  font-family: ${(props: { theme: MyTheme }): string => props.theme.fontFamily.medium};
`

export default PdfCompanyInfo
